export default __webpack_public_path__ + "static/media/icono-autotoma-blanco.60e9f7b8.svg";